import React, { useState } from "react";
import ProcessParticipantPersonForm from "./ProcessParticipantPersonForm";
import { Box, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import ProcessParticipantOrganizationForm from "./ProcessParticipantOrganizationForm";
import { ProductUnion } from "../../../../types/ProductUnion";

type AddProcessParticipantFormProps = {
  product: ProductUnion;
  refreshPage: Function;
};
const AddProcessParticipantForm = ({ product, refreshPage }: AddProcessParticipantFormProps) => {
  const [mode, setMode] = useState("person");

  return (
    <Box>
      <FormControl sx={{ padding: "1rem" }}>
        <FormLabel>Welche Art von Prozessbeteiligten möchten Sie hinzufügen?</FormLabel>
        <RadioGroup row value={mode} onChange={(e) => setMode(e.target.value)}>
          <FormControlLabel value="person" control={<Radio />} label="Person" />
          <FormControlLabel value="organization" control={<Radio />} label="Unternehmen" />
        </RadioGroup>
      </FormControl>
      {mode === "person" ? (
        <ProcessParticipantPersonForm product={product} refreshPage={refreshPage} />
      ) : (
        <ProcessParticipantOrganizationForm product={product} refreshPage={refreshPage} />
      )}
    </Box>
  );
};
export default AddProcessParticipantForm;
